import {QueryFunctionContext} from 'react-query';

import request from 'services/axios';

export const userChats = async (ctx: QueryFunctionContext) => {
  const {data}: {data: IuserChats} = await request.get(
    `/api/v2/chat/market-user-chat?app=${ctx.queryKey[1]}`,
  );
  return data;
};

export const deleteUserChat = async ({guid}: deleteChatService) => {
  const response = await request.delete('/api/v2/chat/chat', {guid});
  return response;
};
